import React from 'react';
import { Card, Typography } from 'antd';
import DynamicLeadDetails from './DynamicLeadDetails';

const { Title } = Typography;

export default function LeadDetailsTest() {
  // Your sample lead data
  const sampleLeadData = {
    "allow_unmerge": false,
    "lead_id": "6c40c8ce-cbe6-4f1c-aeaf-394fef37628d",
    "source_tags": ["Offline", "Site Visit Form"],
    "lead_creation_time": "2025-08-04T09:15:15Z",
    "phones": [{"phone": "+918840016234", "type": "Work", "shared": true}],
    "lead_group": "5636140f-2ecd-44da-838f-be860d516f31",
    "lead_fields": {
      "budget_interested__copy__c02": ["30L-45L"],
      "project_revisited4__copy__a15": ["41 CITY HUB"],
      "unqualified_reason__copy__e95": ["Cibil Issue"],
      "budget_interested_c49": ["30L-45L"],
      "unqualified_reason_128": ["Invalid Number"],
      "customer_id_97b": ["KD16823"],
      "sub_sub_source_1fb": [["loyality"]],
      "buying_purpose_19a51b85": ["Investment"],
      "loyality_source__sales__a03": ["Test2"],
      "reason_fde917d0": ["Fake Lead"],
      "gre_attended_282": ["Rahul Kumar"],
      "sub_source_397": ["Channel Partner"],
      "visit_comments_462": ["Test"],
      "language_924": ["Hindi"],
      "nature_of_work_348": ["salaried"],
      "visit_date__copy__e5d": ["2025-08-22T00:00:00Z"],
      "budget_interested__copy___copy___copy__62d": ["30L-45L"],
      "budget_interested__copy___copy__048": ["30L-45L"],
      "unit_type_1__copy__36c": [["1bhk"]],
      "unit_type__copy__e78": [["1bhk"]],
      "revisit_date2__copy__864": ["2025-08-04T00:00:00Z"],
      "budget_interested__copy___copy___copy___copy___copy__c35": ["90L - 1.15CR"],
      "project_visited_b2b": ["41 ZILLENIA PHASE 2"],
      "unit_type_1__copy___copy___copy__993": [["1bhk"]],
      "remark_9b8": ["Test"],
      "project_visited__copy__5bb": ["41 ZILLENIA PHASE 2"],
      "project_revisited3__copy__735": ["41 ZILLENIA PHASE 2"],
      "unit_type_1__copy___copy__79c": [["1bhk"]],
      "company_name_c66": ["MetroGuild"],
      "interested_in_c5ef20e3": [["4 BHK"]],
      "project_4b930261": [["41 ZILLENIA PHASE 2"]],
      "channel_partner_0f8": ["AAKASH MALIK"],
      "project_revisited1__copy__30a": ["41 ZILLENIA"],
      "revisit_date1__copy__285": ["2025-08-04T00:00:00Z"],
      "location__ac1e6456": [["Pune"]],
      "address_f6f61448": [{"city": "", "country": "", "pincode": "", "longitude": 0, "state": "", "latitude": 0, "address_line": "House Number- 55, Royal City, Bijnor Road"}],
      "state_9d4": ["Uttar Pradesh"],
      "preferrences_563": [["1bhk"]],
      "revisit_date3__copy__659": ["2025-08-04T00:00:00Z"],
      "new_budget_001": ["91 to  1.05 CR"],
      "pincode_a84": ["226014"],
      "revisit_date4__copy__2fe": ["2025-12-24T00:00:00Z"],
      "closing_manager_cb3": ["Ashish Ram Pratap Mishra"],
      "budget_interested__copy___copy___copy___copy__8a7": ["30L-45L"],
      "project_revisited2__copy__386": ["41 ZILLENIA PHASE 2"],
      "unit_type_1__copy___copy___copy___copy__802": [["1bhk"]],
      "city_0b6": [["Lucknow"]],
      "visit_date_ed0": ["2025-08-14T00:00:00Z"]
    },
    "state": "site_visit_done",
    "avg_lead_age_at_state_secs": null,
    "assigned_to": {
      "user_phone": "+917757942640",
      "name": "Inder Kumar",
      "tracking_number": "",
      "id": "b28b3ecd-eb4f-4b74-87c8-3e1a7d61a692"
    },
    "user_assigned_to": "b28b3ecd-eb4f-4b74-87c8-3e1a7d61a692",
    "transitions": {
      "user_assigned_to": [
        {"to": "d2673dfe-a0c9-4e84-aba3-24a7ccafea91", "start_time": 0, "from": null, "end_time": 1754298915, "duration_secs": 0},
        {"to": "9d80488f-b48e-4fbc-a09b-cebff5025bb0", "start_time": 1754298915, "from": "d2673dfe-a0c9-4e84-aba3-24a7ccafea91", "end_time": 1754393943, "duration_secs": 95028},
        {"to": "b28b3ecd-eb4f-4b74-87c8-3e1a7d61a692", "start_time": 1757000180, "from": "9d80488f-b48e-4fbc-a09b-cebff5025bb0", "end_time": 1766733197, "duration_secs": 9733017}
      ],
      "state": [
        {"to": "open", "start_time": 0, "from": null, "end_time": 1754298915, "duration_secs": 0},
        {"to": "lost", "start_time": 1754298915, "from": "open", "end_time": 1754467336, "duration_secs": 168421},
        {"to": "re_visit_done", "start_time": 1754467336, "from": "lost", "end_time": 1755166447, "duration_secs": 699111},
        {"to": "site_visit_done", "start_time": 1755166447, "from": "re_visit_done", "end_time": 1755167288, "duration_secs": 841},
        {"to": "site_visit_done", "start_time": 1755167401, "from": "re_visit_done", "end_time": 1766513069, "duration_secs": 11345668}
      ]
    },
    "emails": [{"shared": true, "type": "Work", "email": "rahul.vasonomics@gmail.com"}],
    "name": "Test Rahul"
  };

  return (
    <div style={{ padding: '20px' }}>
      <Card style={{ marginBottom: '20px' }}>
        <Title level={4}>Sample Lead Data Test</Title>
        <p>This component demonstrates the dynamic lead details extraction from your provided lead object.</p>
      </Card>
      
      <DynamicLeadDetails leadData={sampleLeadData} />
    </div>
  );
}